export default __webpack_public_path__ + "static/media/careernav.0b5327b8.jpg";